/**
 * Enum of supported date formats sent to the API.
 * Formats are dayjs format strings.
 *
 * @enum {string}
 * @readonly
 */
export const ApiDateFormats = Object.freeze({
  DATE: 'YYYY-MM-DD',
});

/**
 * Enum of supported date formats for the date picker.
 * Formats are based on date-fns format strings.
 *
 * @enum {string}
 * @readonly
 */
export const DatePickerFormats = Object.freeze({
  API_FORMAT: 'yyyy-MM-dd',
});

/**
 * Enum of dayjs format strings used to render the date picker's displayed value.
 *
 * @enum {string}
 * @readonly
 */
export const DatePickerDisplayFormats = Object.freeze({
  DATE: 'MMM D, YYYY',
  DATE_VERBOSE: 'MMMM D, YYYY',
});
